import React from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { QuantityCounter, Typography } from '@/components/atoms';
import { IProductSingleVariantCounter } from './IProductSingleVariantCounter';

type IStyledProps = {
  disabled?: boolean;
};

const LineTypography = styled(Typography)<IStyledProps>`
  text-transform: uppercase;
  color: ${props =>
    props.disabled
      ? props.theme.paletteDefault.primary.main
      : props.theme.paletteDefault.primary.main};
`;

const ProductSingleVariantCounter: React.FC<IProductSingleVariantCounter> = ({
  variantChosenQuantity,
  variantInfo,
  extraOptionIncluded,
  extraOptionName,
  onChangeQuantityNoSize,
  initialQuantity,
}) => {
  const { t } = useTranslation('product');

  return (
    <>
      {!initialQuantity ? (
        extraOptionIncluded || !extraOptionName ? ( // ?: maybe it would be clearer if extraOption was included in variantInfo?
          // with color only
          <LineTypography className="smalltitle" disabled>
            {t('sold-out')}
          </LineTypography>
        ) : null // with color and extra option
      ) : (
        // no sold out case
        <QuantityCounter
          key={variantInfo?.variant_id}
          debounce={false}
          minValue={1}
          quantity={variantChosenQuantity ?? initialQuantity}
          template="medium"
          changeQuantityHandler={e =>
            onChangeQuantityNoSize(e, variantInfo?.variant_id)
          }
        />
      )}
    </>
  );
};

export default ProductSingleVariantCounter;
